
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-integrations/lead-squared",
      function () {
        return require("private-next-pages/whatsapp-integrations/lead-squared.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-integrations/lead-squared"])
      });
    }
  